import { useEffect, useState } from 'react';

/**
 * Subscribes to changes of the `vonlof-theme-cookie` cookie so the cookie
 * banner can stay hidden across reloads after dismissal.
 */
export function useCookieConsent(): {
  hasConsented: boolean | null;
  accept: () => void;
  decline: () => void;
} {
  const [hasConsented, setHasConsented] = useState<boolean | null>(() => {
    if (typeof document === 'undefined') return null;
    return document.cookie.includes('vonlof-cookie-consent=');
  });

  // Sync across tabs.
  useEffect(() => {
    const onStorage = () => {
      setHasConsented(document.cookie.includes('vonlof-cookie-consent='));
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const setCookie = (value: 'accepted' | 'declined') => {
    const oneYear = 60 * 60 * 24 * 365;
    document.cookie = `vonlof-cookie-consent=${value}; path=/; max-age=${oneYear}; SameSite=Lax`;
    setHasConsented(true);
  };

  return {
    hasConsented,
    accept: () => setCookie('accepted'),
    decline: () => setCookie('declined'),
  };
}